import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, renderComponent } from 'recompose';

import MediaIndicator from '../MediaIndicator';
import PatientControls from './PatientControls';
import Icon from '../../../Icon';
import styles from './styles.styl';
import { useSubscriberControls } from '../../utils/useSubscriberControls';
import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';

function SubscriberBtns({ connection: { entity, id } = {}, onPin, pinnedId }) {
  const pinned = pinnedId === id;

  const {
    handleVideoToggle,
    handleAudioToggle,
    handlePinToggle,
    audioIcon,
    videoIcon,
    pinIcon,
    hasAudio,
    hasVideo,
  } = useSubscriberControls({ pinned, onPin, id, entity });

  return (
    <div className={styles.root}>
      <div className={styles.overlay} />
      <div className={styles.actions}>
        <button
          onClick={handleAudioToggle}
          className={styles.btn}
          type="button"
        >
          <Icon name={audioIcon} size={24} />
        </button>
        <button
          onClick={handleVideoToggle}
          className={styles.btn}
          type="button"
        >
          <Icon name={videoIcon} size={24} />
        </button>
        <button onClick={handlePinToggle} className={styles.btn} type="button">
          <Icon name={pinIcon} size={24} />
        </button>
      </div>
      <MediaIndicator
        className={styles.controls}
        pinned={pinned}
        noVideo={!hasVideo}
        noAudio={!hasAudio}
      />
    </div>
  );
}

SubscriberBtns.propTypes = {
  connection: ConnectionShape,
  pinnedId: PropTypes.string,
  onPin: PropTypes.func,
};

const enhance = compose(
  branch(({ isProvider }) => !isProvider, renderComponent(PatientControls)),
);

export default enhance(SubscriberBtns);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/SubscriberBtns/index.jsx